"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const a = ({
  title: r,
  titleId: t,
  desc: i,
  descId: n,
  ...o
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": "true",
    viewBox: "-.75 -.75 16 16",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": n,
    ...o,
    children: [
      r ? /* @__PURE__ */ e("title", { id: t, children: r }) : null,
      i === void 0 ? /* @__PURE__ */ e("desc", { id: n, children: `
    Chevron Right Streamline Icon: https://streamlinehq.com
  ` }) : i ? /* @__PURE__ */ e("desc", { id: n, children: i }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m4.0204.791 6.4592 6.459-6.4592 6.459"
        }
      )
    ]
  }
);
export {
  a as default
};
//# sourceMappingURL=ChevronRightOutline.js.map
